<template>
  <div class="main flex">
    <div class="overflow_content" :class="mobile_compult">
      <Menu :page="isPage"></Menu>
    </div>
    <!-- <div v-else class="main__left overflow_content">
      <Menu :page="isPage"></Menu>
    </div> -->
    <div class="main__right overflow_content">
      <Header :mobile="mobile" :nav_status.sync="nav_status"></Header>
      <div class="main__conten">
        <router-view />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.main {
  width: 100%;
  position: relative;

  &__mobile_open {
    flex: 3;
  }

  &__mobile {
    flex: 0;
  }

  &__left {
    flex: 1.4;
  }

  &__right {
    background: #f3f3f3;
    flex: 8.5;
  }

  .main__conten {
    padding: 30px;
  }
}
</style>
<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/AdminMenu.vue";
export default {
  name: "mainBlock",
  data() {
    return {
      isPage: `${this.$route.path.split("/")[1]}`,
      screen_width: document.body.clientWidth,
      nav_status: false,
    };
  },
  components: {
    Header,
    Menu,
  },
  computed: {
    mobile() {
      //平板尺寸
      if (this.screen_width > this.$store.state.pad_size) {
        return false;
      } else {
        return true;
      }
    },
    mobile_compult() {
      //如果是平板狀態的導覽列，要比較寬一點，所以會有三種class
      if (this.mobile && this.nav_status) {
        return 'main__mobile_open'
      } else if (this.mobile) {
        return 'main__mobile'
      } else {
        return 'main__left'
      }
    }
  },
  methods: {
    screen() {
      const that = this;
      window.onresize = function () {
        that.screen_width = document.body.clientWidth;
      };
    },
  },
};
</script>